import React from 'react'
import {Loader as LoaderIcon} from 'lucide-react'

const Loader = () => (
    <div className="w-full my-20 flex justify-center">
        <LoaderIcon className="w-10 h-10" data-testid="Loader-LoaderIcon" />
    </div>
)

export {Loader}
